import { useFeatureFlag } from '@moda/portal-stanchions';
import { useAdminMode } from '../components/AdminMode/AdminModeProvider';
import { usePLPParams } from './usePLPParams';

export const useIsPinningDisabledOnPLP = () => {
  const {
    params: { section }
  } = usePLPParams();
  const { noPinning: isPinningDisabledFromAdminMode } = useAdminMode();

  // eslint-disable-next-line @moda/no-default-enabled-feature-flags
  const isPinningEnabledFromFeatureFlag = useFeatureFlag('plp-pins', [
    { default: true },
    { if: false, then: false }
  ]);

  // New arrivals pages should always have pinning enabled regardless of the feature flag.
  const enablePinningRegardlessOfFeatureFlag = section === 'new';

  return (
    isPinningDisabledFromAdminMode ||
    (!isPinningEnabledFromFeatureFlag && !enablePinningRegardlessOfFeatureFlag)
  );
};
